import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [visible, setVisible] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  useEffect(() => {
    if (isHome) {
      // Delay navbar appearance to match video fade (3500ms)
      const timer = setTimeout(() => setVisible(true), 3500);
      return () => clearTimeout(timer);
    } else {
      setVisible(true);
    }
  }, [isHome]);

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''} ${isHome && !visible ? 'navbar-hidden' : 'navbar-visible'}`}>
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img src="/images/logo.png" alt="Wordalanche" className="navbar-logo-img" />
        </Link>

        <button
          className={`navbar-toggle ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul className={`navbar-menu ${menuOpen ? 'open' : ''}`}>
          <li><Link to="/">Home</Link></li>
          <li><a href="/#features">Features</a></li>
          <li><a href="/#how-to-play">How to Play</a></li>
          <li><Link to="/support">Support</Link></li>
          <li>
            <a
              href="https://apps.apple.com/app/wordalanche"
              className="btn btn-primary navbar-cta"
              target="_blank"
              rel="noopener noreferrer"
            >
              Download
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
